import styled from 'styled-components';

export const Card = styled.article`
  display: flex;
  flex-direction: column;
  justify-content:space-between;
  cursor: pointer;
  padding: 1.6rem;
	border: 1px solid rgba(0,0,0,0.08);
	background-color:#fff;
	box-shadow: 0 5px 10px rgba(0,0,0,0.20);
	border-radius: 12px;
  transition: all 0.3s ease 0s;
  a{
  height:100%;
  text-decoration:none;
  display: flex;
  flex-direction: column;
  justify-content:center;
  }
img{
  width: 100%;
}
    &:hover {
      transform: translateY(-7px);
    }
`;


export const Title = styled.h2`
    margin: 1.6rem 0 1.0rem 0;
		font-size: 1.7rem;
		font-weight: 600;
    line-height: 2.4rem;
    opacity: 1;
		color: #0B1DA5;

`;

export const Author = styled.p`
    margin-top: 1.0rem;
  	font-size: 1.3rem;
		color: rgba(0,0,0,0.7);
`;
